import { render, staticRenderFns } from "./ItemMain.vue?vue&type=template&id=6572e349"
import script from "./ItemMain.vue?vue&type=script&lang=js"
export * from "./ItemMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports